<template>
	<v-row class="" style="position: relative">
		<v-col cols="10" sm="5" :class="leftClass" class="pa-4">
			<div v-if="side == 'left'">
				<h4 class="font-weight-bold">{{title}}</h4>
				<p>{{text}}</p>
			</div>
		</v-col>
		<v-col cols="2" class="text-center" :class="{ 'fake-border': !isMobile }">

			<v-avatar :height="avatarHeight" :width="avatarHeight" class="elevation-1 primary--text process-avatar">{{number}}</v-avatar>
		</v-col>
		<v-col cols="10" sm="5" class="pa-4">
			<div v-if="side == 'right' || isMobile ">
				<h4 class="font-weight-bold">{{title}}</h4>
				<p>{{text}}</p>
			</div>
		</v-col>
	</v-row>
</template>

<style lang="less">
	.process-avatar{
		font-size: 1.7em;
		background-color: white;
	}
	.fake-border::before {
		content: " ";
		z-index: 0;
		position: absolute;
		height: 100%;
		left: 50%;
		border-left: 1px dashed #ccc;
	}
</style>

<script type="text/javascript">
	// import Vuex from "vuex";
	// import - from "@/components/"
	export default {
		name: "", 
		props: {
			title: { type: String },
			number: { type: String }, 
			text: { type: String }, 
			side: { type: String, default: () => 'left' }
		},
		data: () => {
			return {

			}
		},
		// components: {

		// },
		computed: {
			// ...Vuex.mapState({})

			isMobile(){
				return (this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs)
			},
			avatarHeight(){
				return this.isMobile ? 48 : 70	
			},
			leftClass(){
				var classes = {}
				if( this.side == "right" || this.isMobile ){
					classes["d-none"] = true
				}
				if( !this.isMobile ){
					classes["d-sm-block"] = true
					classes["text-right"] = true
				}
				return classes;
			},
			rightClass(){
				var classes = {}
				if( this.side == "left" ){
					classes["d-none"] = true
					classes["d-sm-block"] = true
				}
				return classes;
			}
		},
		// methods: {
		// }
		// created(){

		// }

	}
</script>